import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {combineLatest, mergeMap, Observable, of} from "rxjs";
import {DealsService} from "../../../store/entity/entity-services/deals.service";
import {BooleanValue, firstByKey, selectEntity, SubscribedContainer} from "@digidom/common";
import {filter, map, takeUntil} from "rxjs/operators";
import {StagesService} from "../../../store/entity/entity-services/stages.service";

@Component({
  selector: 'dd-deal-stage-bar',
  templateUrl: './deal-stage-bar.component.html',
  styleUrls: ['./deal-stage-bar.component.scss']
})
export class DealStageBarComponent extends SubscribedContainer implements OnInit, OnChanges {

  @Input()
  dealId: string | undefined;

  stageLights$: Observable<Array<{
    id: string,
    name: string,
    order: number,
    active: boolean
  }>> | undefined;

  isLost = false;

  constructor(public dealsService: DealsService,
              public stagesService: StagesService) {
    super();
  }

  ngOnInit(): void {

  }

  ngOnChanges(): void {
    this.stageLights$ = combineLatest([
      selectEntity(this.dealsService, this.dealId),
      this.stagesService.entities$
    ]).pipe(
      filter(([deal, stages]) => {
        return !!deal;
      }),
      mergeMap(([deal, stages]) => {
        return combineLatest([of(deal), of(stages.filter(stage => {
          return stage.pipeline_id === deal?.pipeline.pipeline_id;
        }))])
      }),
      map(([deal, stages]) => {
      const stageLights = new Array<{ id: string, name: string, order: number, active: boolean }>();
      if (!deal?.pipeline.stage_id) {
        return stageLights;
      }
      const currentStage = firstByKey(stages, 'id', deal?.pipeline.stage_id);

      if (currentStage?.progress === 0){
        return stageLights;
      }

      const order = currentStage?.order ? currentStage.order : 0;

      for (const stage of stages.filter(stage => stage.progress > 0)) {
        stageLights.push({
          id: stage.id,
          active: stage.order <= order,
          name: stage.name,
          order: stage.order
        });
      }
      return stageLights;
    }));

    combineLatest([
      selectEntity(this.dealsService, this.dealId),
      this.stagesService.entities$
    ]).pipe(
      takeUntil(this.destroyed$),
      map(([deal, stages]) => {

        if (deal){
          const currentStage = firstByKey(stages, 'id', deal?.pipeline.stage_id);

          this.isLost = currentStage?.progress === 0;
        }


      })
    ).subscribe();
  }

}
